import { render, staticRenderFns } from "./CashregisterDetails.vue?vue&type=template&id=2409f608&scoped=true&"
import script from "./CashregisterDetails.vue?vue&type=script&lang=js&"
export * from "./CashregisterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2409f608",
  null
  
)

export default component.exports